import React, { useState, useEffect } from "react";
import { getArticles } from "../firestoreServices";
import { Link } from "react-router-dom";

const Library = ({ lang }) => {
  const [articles, setArticles] = useState([]);

  const staticText = {
    ar: {
      sub: "المعرفة القانونية",
      title: "المكتبة والمدونة",
      desc: "تابع أحدث التحليلات...",
      read: "اقرأ المقال",
    },
    en: {
      sub: "Legal Insights",
      title: "Library & Blog",
      desc: "Stay updated...",
      read: "Read Article",
    },
  };
  const t = staticText[lang];
  const isAr = lang === "ar";

  useEffect(() => {
    getArticles().then((data) => setArticles(data));
  }, []);

  return (
    <section
      className="library-section"
      id="library"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="container">
        <div className="section-header center">
          <h4 className="sub-heading">{t.sub}</h4>
          <h2 className="main-heading">{t.title}</h2>
          <div className="heading-line"></div>
          <p className="header-desc">{t.desc}</p>
        </div>

        <div className="articles-grid">
          {articles.map((article) => {
            const data = article[lang] || article.en; // اختيار اللغة
            return (
              <div className="article-card" key={article.id}>
                <div className="article-img-box">
                  <img
                    src={article.img}
                    alt={data.title}
                    className="article-img"
                  />
                  <span className="article-category">{data.category}</span>
                </div>
                <div className="article-content">
                  <span className="article-date">{article.date}</span>
                  <h3 className="article-title">{data.title}</h3>
                  <p className="article-excerpt">{data.excerpt}</p>
                  <Link to={`/article/${article.id}`} className="read-more-btn">
                    {t.read}{" "}
                    <span className="arrow-icon">{isAr ? "←" : "→"}</span>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Library;
